import {Injectable} from "@angular/core";
import {DataPermissions, DataPermissionType, Permissions, IDBObject} from "@models";

@Injectable({
	providedIn: "root",
})
export class SimPermissionService {
	constructor() {}

	public HasPerm(entity: {permissions: Permissions[]}, permission: Permissions): boolean {
		if (!permission) {
			return true;
		}

		if (entity && entity.permissions) {
			let permissions = entity.permissions;
			return permissions.some((x) => x === permission || x?.toString() === Permissions[permission]);
		}
		return false;
	}

	public HasDataPerm(
		entity: IDBObject,
		dataPermission: DataPermissions,
		dataPermissionType: DataPermissionType = DataPermissionType.Self,
	): boolean {
		dataPermissionType = dataPermissionType | DataPermissionType.Self;

		if (entity && entity.permissions) {
			let permissions = entity.permissions[dataPermissionType];
			if (permissions) {
				return permissions.some((x) => x === dataPermission || x.toString() === DataPermissions[dataPermission]);
			}
		}

		return false;
	}
}
